<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <!-- Dialog for acceptance of relationship request -->
      <v-dialog
        v-model="acceptanceMsg"
        persistent :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Thank you for accepting the mentoring relationship request.</span>
          </v-card-title>
          <v-card-text>
            <v-layout align-start>
              <span class="subheading">
                Please remember to return periodically to update the relationship record.
              </span>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" flat @click="hideAcceptanceMsg">Cancel</v-btn>
          </v-card-actions>
          

        </v-card>
      </v-dialog>
      <!-- Dialog to capture rejection reason -->
      <v-dialog
        v-model="rejectionReason"
        persistent :overlay="false"
        max-width="600px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Reason why relationship will not go forward</span>
          </v-card-title>
          <v-card-text>
            <v-layout align-start>
              <span class="subheading">Please confirm you have spoken with the client.&nbsp;</span>
              <v-checkbox 
                color="primary"
                v-model="conversationConfirmation"
                title="Confirmation"
                :error="confirmationError"
                :error-messages="confirmationErrorMsg">
              </v-checkbox>
            </v-layout>
            <div v-if="conversationConfirmation">
              <span class="subheading">Please select a reason for turning down this client request.</span>
              <v-select
                :items="configData.rejectionReasons"
                v-model="rejectionText"
                name="reason"
                label="Reason"
                :error="rejectError"
                :error-messages="rejectErrorMsg"
              ></v-select>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="secondary" flat @click="closeRejection">Cancel</v-btn>
            <v-btn color="primary" flat @click="saveRejection">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog to display/update relationship info -->
      <v-dialog
        v-model="dialog"
        scrollable  
        persistent
        max-width="850px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">
              Relationship Information for {{viewedItem.name}} 
            </span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <!-- Visible for clients when relationship is 'requested' -->
              <v-layout row wrap v-if="wholeItem.relationshipStatus == 'requested' && wholeItem.client.email == myProfile.email">
                <v-flex xs12>
                  <span class="subheading">
                    The relationship request is still being considered by the mentor
                  </span>
                </v-flex>
                <v-flex xs10 offset-xs1>
                  {{wholeItem.rejectionReason}}
                </v-flex>
              </v-layout>
              <!-- Always visible -->
              <v-layout wrap v-if="!((wholeItem.relationshipStatus == 'requested' || wholeItem.relationshipStatus == 'rejected') && wholeItem.client.email == myProfile.email)">
                <v-flex xs12>
                  <span class="title">
                    {{detailTitle}} Contact Details
                  </span>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.email"
                    readonly
                    hide-details
                    label="Email"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.location" 
                    readonly
                    hide-details
                    label="Location"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedItem.telephone" 
                    readonly
                    hide-details
                    label="Telephone"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="chosenProfile.role" 
                    readonly
                    hide-details
                    label="Role"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    :key="autoGrowHack3"
                    v-model="chosenProfile.bio" 
                    readonly
                    auto-grow
                    rows="1"
                    label="Background"></v-textarea>
                </v-flex>
              </v-layout>
              <!-- Only visible for rejected relationships -->
              <v-layout row wrap v-if="wholeItem.relationshipStatus == 'rejected'">
                <v-flex xs12>
                  <span class="subheading">
                    The relationship request was turned down for the following reason
                  </span>
                </v-flex>
                <v-flex xs10 offset-xs1>
                  {{wholeItem.rejectionReason}}
                </v-flex>
              </v-layout>
              <!-- Only visible for active and complete relationships -->
              <v-layout row wrap v-if="wholeItem.relationshipStatus == 'active' || wholeItem.relationshipStatus == 'complete'">
                <v-flex xs12>
                  <span class="title">
                    Relationship Details
                  </span>
                </v-flex>
                <v-flex xs3>
                  <div v-if="wholeItem.relationshipStatus == 'active' && wholeItem.mentor.email == myProfile.email">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="computedDateFormatted"
                        label="First meeting date"
                        append-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="wholeItem.firstMeeting" @input="menu = false"></v-date-picker>
                    </v-menu>
                  </div>
                  <div v-else>
                    <v-text-field
                        slot="activator"
                        v-model="computedDateFormatted"
                        label="First meeting date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <!-- empty flex box for spacing -->
                </v-flex>
                <v-flex xs12>
                  <em>Note: The below feedback relates to the use of the system and overall outcomes, not feedback on the quality of the mentor/mentoring relationship - the feedback is visible to both parties.</em>
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    :key="autoGrowHack1"
                    v-model="wholeItem.feedback.mentor"
                    auto-grow
                    label="Mentor Feedback"
                    :readonly = "wholeItem.relationshipStatus != 'active' || wholeItem.mentor.email != myProfile.email"
                  ></v-textarea>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs6>
                  <v-textarea
                    :key="autoGrowHack2"
                    v-model="wholeItem.feedback.client"
                    auto-grow
                    label="Client Feedback"
                    :readonly = "wholeItem.relationshipStatus != 'active' || wholeItem.client.email != myProfile.email"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <template v-if="wholeItem.relationshipStatus == 'active'">
              <v-btn
                color="secondary"
                flat
                @click="dialogSave">
                  Save
              </v-btn>
            </template>
            <v-spacer></v-spacer>
            <v-btn 
              color="blue darken-1"
              flat 
              @click="close">
                Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-------------------------->
      <!-- Table of my clients  -->
      <!-------------------------->
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card v-if="myClients.length > 0">
          <v-toolbar dark dense color="primary">
            <v-toolbar-title class="title">
            My Clients
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn 
                slot="activator"
                flat
                icon
                dark
                @click="showHelpMentor = !showHelpMentor">
                  <v-icon>help_outline</v-icon>
              </v-btn>
              <span v-if="!showHelpMentor">Show help</span>
              <span v-else>Hide help</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-title v-if="showHelpMentor">
            <template>
              <v-layout row wrap>
                <v-flex xs12>
                  <p class="text-xs-left">The status of your mentoring relationships can be viewed and updated here.  Relationships can be either pending (waiting for a response from the mentor), current or complete.</p>
                  <p class="text-xs-left">This page can also be used to provide feedback on the suitability of the relationship from the perspective of mentor and mentee.  Please do NOT use this for personal feedback, which should always be shared directory and confidently with the mentor or mentee.</p>
                </v-flex>
              </v-layout>
            </template>
          </v-card-title>

          <v-data-table
            :headers="clientHeaders"
            :items="myClients"
            :loading="clientsLoading"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.client.name }}</td>
              <td class="text-xs-left">{{ props.item.client.location }}</td>
              <td class="text-xs-left">
                <v-tooltip right v-if="props.item.relationshipStatus == 'requested'">
                  <v-icon
                    slot="activator"
                    color="primary"
                  >
                    help_outline
                  </v-icon>
                  <span>Relationship request</span>
                </v-tooltip>
                <v-tooltip right v-else-if="props.item.relationshipStatus == 'active'">
                  <v-icon
                    slot="activator"
                    color="secondary"
                  >
                    people_outline
                  </v-icon>
                  <span>Active relationship</span>
                </v-tooltip>
                <v-tooltip right v-else-if="props.item.relationshipStatus == 'rejected'">
                  <v-icon
                    slot="activator"
                    color="secondary"
                  >
                    highlight_off
                  </v-icon>
                  <span>Relationship turned down</span>
                </v-tooltip>
                <v-tooltip right v-else>
                  <v-icon
                    slot="activator"
                    color="secondary"
                  >
                    check_circle_outline
                  </v-icon>
                  <span>Completed Relationship</span>
                </v-tooltip>
              </td>

              <td class="justify-center layout px-0">
                <v-tooltip left>
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="viewClient(props.item)"
                  >
                    visibility
                  </v-icon>
                  <span v-if="props.item.relationshipStatus == 'requested'">View client details</span>
                  <span v-else>View relationship details</span>
                </v-tooltip>
              
                <v-tooltip top v-if="props.item.relationshipStatus == 'requested'">
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="changeRelationshipStatus(props.item,'active')"
                  >
                    thumb_up_alt
                  </v-icon>
                  <span>Take on client</span>  
                </v-tooltip>
                <v-tooltip bottom v-if="props.item.relationshipStatus == 'requested'">
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="rejectClient(props.item)"
                  >
                    thumb_down_alt
                  </v-icon>
                  <span>Turn down client</span>  
                </v-tooltip>
                <v-tooltip right v-if="props.item.relationshipStatus == 'active'">
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="changeRelationshipStatus(props.item,'complete')"
                  >
                    close
                  </v-icon>
                  <span>Complete Relationship</span>  
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>

      <!-------------------------->
      <!-- Table of my mentors  -->
      <!-------------------------->
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1 pt-2>
        <v-card v-if="myMentors.length > 0">
          <v-toolbar dark dense color="primary">
            <v-toolbar-title class="title">
            My Mentors
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn 
                slot="activator"
                flat
                icon
                dark
                @click="showHelpClient = !showHelpClient">
                  <v-icon>help_outline</v-icon>
              </v-btn>
              <span v-if="!showHelpClient">Show help</span>
              <span v-else>Hide help</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-title v-if="showHelpClient">
            <template>
              <v-layout row wrap>
                <v-flex xs12>
                  <p class="text-xs-left">The status of your mentoring relationships can be viewed here.  Relationships can be either pending (waiting for a response from the mentor), current or complete.</p>
                  <p class="text-xs-left">This page can also be used to provide feedback on the suitability of the relationship from the mentee perspective.  Please do NOT use this for personal feedback, which should always be shared directly, and in confidence, with your mentor.</p>
                </v-flex>
              </v-layout>
            </template>
          </v-card-title>

          <v-data-table
            :headers="mentorHeaders"
            :items="myMentors"
            :loading="mentorsLoading"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.mentor.name }}</td>
              <td class="text-xs-left">{{ props.item.mentor.location }}</td>
              
              <td class="text-xs-left">
                <v-tooltip right v-if="props.item.relationshipStatus == 'requested'">
                  <v-icon
                    slot="activator"
                    color="primary"
                  >
                    help_outline
                  </v-icon>
                  <span>Relationship request</span>
                </v-tooltip>
                <v-tooltip right v-else-if="props.item.relationshipStatus == 'active'">
                  <v-icon
                    slot="activator"
                    color="secondary"
                  >
                    people_outline
                  </v-icon>
                  <span>Active relationship</span>
                </v-tooltip>
                <v-tooltip right v-else-if="props.item.relationshipStatus == 'rejected'">
                  <v-icon
                    slot="activator"
                    color="secondary"
                  >
                    highlight_off
                  </v-icon>
                  <span>Relationship turned down</span>
                </v-tooltip>
                <v-tooltip right v-else>
                  <v-icon
                    slot="activator"
                    color="secondary"
                  >
                    check_circle_outline
                  </v-icon>
                  <span>Completed Relationship</span>
                </v-tooltip>
              </td>
              <td class="justify-center layout px-0">
                <v-tooltip left>
                  <v-icon
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="viewMentor(props.item)"
                  >
                    visibility
                  </v-icon>
                  <span>View relationship details</span>  
                </v-tooltip>
              </td>

            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <!------------------------------->
      <!-- Text for no relationships -->
      <!------------------------------->
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1 pt-2 v-if="myMentors.length == 0 && myClients.length == 0">
        <h1 class="text-xs-center headline">
          You currently have no mentoring{{coachText}} relationships to display.
        </h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      menu: false,
      autoGrowHack1: false,
      autoGrowHack2: false,
      autoGrowHack3: false,
      search: '',
      dialog: false,
      rejectionReason: false,
      rejectionText: null,
      rejectError: false,
      rejectErrorMsg: null,
      confirmationError: false,
      confirmationErrorMsg: null,
      mentorHeaders: [
        { text: 'Mentor', value: 'name'},
        { text: 'Location', value: 'location'},
        { text: 'Status', value: 'relationshipStatus'}
      ],
      clientHeaders: [
        { text: 'Client', value: 'name'},
        { text: 'Location', value: 'location'},
        { text: 'Status', value: 'relationshipStatus'}
      ],
      viewedIndex: -1,
      viewedItem: {},
      selectedItem: {},
      wholeItem: {},
      selectedMentor: {},
      defaultItem: {},
      detailTitle: null,
      conversationConfirmation: false,
      showHelpMentor: false,
      showHelpClient: false
    }),
    created: function() {
      this.$store.dispatch("updateMyMentors")
      this.$store.dispatch("updateMyClients")
    },
    computed: {
      myMentors: function() {
        return this.$store.getters.getMyMentors
      },
      myClients: function() {
        return this.$store.getters.getMyClients
      },
      myProfile: function() {
        return this.$store.getters.getMyProfile
      },
      chosenProfile: function() {
        return this.$store.getters.getChosenProfile
      },
      configData: function () {
        //return this.$store.getters.getForms
        return this.$store.getters.getConfig
      },
      mentorsLoading: function () {
        return this.$store.getters.getMentorLoading
      },
      clientsLoading: function () {
        return this.$store.getters.getClientLoading
      },
      acceptanceMsg: function () {
        return this.$store.getters.getAcceptanceMsg
      },
      computedDateFormatted () {
        return this.formatDate(this.wholeItem.firstMeeting)
      },
      includeCoach: function () {
        return this.$store.getters.getIncludeCoach
      },
      coachText: function () {
        if (this.includeCoach) {
          return '/coaching'
        } else {
          return ''
        }
      }
    },
    methods: {
      viewMentor (item) {
        this.viewedIndex = this.myMentors.indexOf(item)
        this.viewedItem = Object.assign({}, item.mentor)
        this.wholeItem = Object.assign({}, item)
        this.detailTitle = "Mentor"
        // get the profile of the selected user
        this.$store.dispatch('updateChosenProfile', this.viewedItem.email)
          .then((id) => {
            console.log("REL - viewedItem", this.viewedItem)
            console.log("REL - wholeItem", this.wholeItem)
            console.log("REL - Title for", this.detailTitle)
            this.dialog = true
            this.autoGrowHack1 = !this.autoGrowHack1
            this.autoGrowHack2 = !this.autoGrowHack2
            this.autoGrowHack3 = !this.autoGrowHack3
          }, (error) => {
            // output an error message
          })
      },
      viewClient (item) {
        this.viewedIndex = this.myClients.indexOf(item)
        this.viewedItem = Object.assign({}, item.client)
        this.wholeItem = Object.assign({}, item)
        this.detailTitle = "Client"
        // get the profile of the selected user
        this.$store.dispatch('updateChosenProfile', this.viewedItem.email)
          .then((id) => {
            console.log("REL - viewedItem", this.viewedItem)
            console.log("REL - wholeItem", this.wholeItem)
            console.log("REL - Title for", this.detailTitle)
            this.dialog = true
            this.autoGrowHack1 = !this.autoGrowHack1
            this.autoGrowHack2 = !this.autoGrowHack2
            this.autoGrowHack3 = !this.autoGrowHack3
          }, (error) => {
            // output an error message
          })
      },
      rejectClient (item) {
        this.wholeItem = Object.assign({}, item)
        console.log("REL - rejection Text 1 ",this.rejectionText)
        this.confirmationError = false
        this.confirmationErrorMsg = null
        this.rejectError = false
        this.rejectErrorMsg = null
        this.conversationConfirmation = false
        this.rejectionText = null
        this.rejectionReason = true
      },
      changeRelationshipStatus (item,newStatus) {
        var clientObj = Object.assign({}, item)
        clientObj.relationshipStatus = newStatus
        console.log("REL - acceptedItem", clientObj)
        this.$store.dispatch("changeRelationshipStatus",clientObj)
      },
      closeRejection () {
        console.log("REL - rejection Text 2 ",this.rejectionText)
        this.confirmationError = false
        this.confirmationErrorMsg = null
        this.rejectError = false
        this.rejectErrorMsg = null
        this.rejectionText = null
        this.rejectionReason = false
        setTimeout(() => {
          this.wholeItem = Object.assign({}, this.defaultItem)
        }, 300)
      },
      saveRejection () {
        if (this.conversationConfirmation == false) {
          this.confirmationError = true
          this.confirmationErrorMsg = "Please confirm"
        } else if (this.rejectionText == null || this.rejectionText == "") {
          this.rejectError = true
          this.rejectErrorMsg = "Please enter a Reason"
        } else {
          this.rejectError = false
          this.rejectErrorMsg = null
          this.rejectionReason = false
          console.log("REL - rejection Text 3 ",this.rejectionText)
          this.wholeItem.rejectionReason = this.rejectionText
          this.changeRelationshipStatus(this.wholeItem,"rejected")
        }
      },
      dialogSave () {
        console.log("REL - out of dialog ",this.wholeItem)
        this.$store.dispatch("saveRelationship",this.wholeItem)
        this.close()

      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.viewedItem = Object.assign({}, this.defaultItem)
          this.wholeItem = Object.assign({}, this.defaultItem)
          this.viewedIndex = -1
        }, 300)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      hideAcceptanceMsg () {
        this.$store.commit('setAcceptanceMsg',false)
      }
    }
  }
</script>

<style>

</style>
